import useCtcae, { ICtcaeIdentifier } from "@/hooks/data/useCtcae";
import { faDownload, faInfoSquare } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, CircularProgress, Divider, IconButton, styled, Tooltip, Typography } from "@mui/material";
import { FormsFeatureContext } from "@ngt/forms";
import { FC, useContext, useMemo } from "react";
import { Field, Format } from ".";


const CtcaeTooltip = styled(Box)(({ theme }) => ({
    margin: theme.spacing( -1),
}));

const CtcaeTooltipBox = styled(Box)(({ theme }) => ({
    margin: theme.spacing(0, -1),
    padding: theme.spacing(2, 3, 2, 3)
}));

const SourceDataFileValue: FC<{formFieldValue?: string; oldValue?: boolean; newValue?: boolean;  noBox?: boolean }> = ({
    formFieldValue,
    oldValue,
    newValue,
    noBox
}) => {

    const fileName = useMemo(() => {

        if (!formFieldValue) {
            return undefined;
        }

        const forwardSlashIndex = formFieldValue?.lastIndexOf('/');
        const backSlashIndex = formFieldValue?.lastIndexOf('\\');

        if (forwardSlashIndex !== -1 && backSlashIndex !== -1) {
            const index = forwardSlashIndex < backSlashIndex ? backSlashIndex : forwardSlashIndex;

            return formFieldValue.substring(index + 1);
        }
        else if (forwardSlashIndex !== -1) {
            return formFieldValue.substring(forwardSlashIndex + 1);
        }
        else if (backSlashIndex !== -1) {
            return formFieldValue.substring(backSlashIndex + 1);
        }

        return formFieldValue;
    }, [formFieldValue]);

    const formsFeature = useContext(FormsFeatureContext);

    return (
        <Field
            // @ts-ignore-next-line
            newValue={newValue ? "1" : undefined} 
            oldValue={oldValue ? "1" : undefined}
            noBox={noBox ? "1" : undefined}
        >
            <Format sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis'}}>{fileName}</Box>
                {
                    formFieldValue && (
                        <Tooltip 
                            title="Download"
                        >
                            <IconButton 
                                sx={{borderRadius: 0, padding: 0, marginTop: -1, marginBottom: -1, marginLeft: 2, alignSelf: 'top'}} 
                                color="info" 
                                component="a" 
                                target="_blank" 
                                href={`${formsFeature.baseRoute}/open-clinica/document?FileName=${encodeURIComponent(formFieldValue)}`}
                            >
                                <FontAwesomeIcon icon={faDownload} />
                            </IconButton>
                        </Tooltip>
                    )
                }
            </Format>
        </Field>
    )
}

export default SourceDataFileValue;